import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import axiosInstance from "../../../services/AxiosInstance";
import Api from "../../../constants/Api";
import { successAlert } from "../alert/defaultAlert";
import YesNoSelect from "../Common/YesNoSelect";
import { convertBooleanToYesOrNo, convertYesOrNoToBoolean } from "../../../utils/ConverterUtils";
import HintTooltip from "../Common/HintTooltip";

const SalesSetting = () => {

    const { t } = useTranslation();
    const buildYesNoOption = useCallback((value) => {
        const yesNoValue = convertBooleanToYesOrNo(Boolean(value));
        return {
            value: yesNoValue,
            label: yesNoValue === "Y" ? t('yes') : t('no')
        };
    }, [t]);

    const [requireEmployee, setRequireEmployee] = useState(buildYesNoOption(false));
    const [blockSubscriptionSaleForDelinquent, setBlockSubscriptionSaleForDelinquent] = useState(buildYesNoOption(true));

    const save = () => {
        let data = {
            requireEmployee: convertYesOrNoToBoolean(requireEmployee.value),
            blockSubscriptionSaleForDelinquent: convertYesOrNoToBoolean(blockSubscriptionSaleForDelinquent.value)
        }

        axiosInstance.post(Api.parameter.sales, data).then(() => successAlert(t('message.data_updated_successfully'), null));
    }

    useEffect(() => {
        axiosInstance.get(Api.parameter.sales)
            .then((resp) => {
                if (resp.data.length > 0) {
                    let data = resp.data[0];
                    setRequireEmployee(buildYesNoOption(data.requireEmployee));
                    setBlockSubscriptionSaleForDelinquent(buildYesNoOption(data.blockSubscriptionSaleForDelinquent ?? true));
                }
            });
    }, [buildYesNoOption]);

    return (
        <div className="card">
            <div className="card-body">
                <h3 className="mb-2">{t('sales')}</h3>
                <p className="text-muted small mb-4">O módulo de vendas oferece configurações personalizáveis para otimizar suas transações e gerenciar as regras de comissionamento e faturamento do seu negócio.</p>
                <hr className="my-4" />
                <div className="row">
                    <div className="col-md-6">
                        <div className="setting-input">
                            <label className="form-label">{t('require_employee_sale_question')} <HintTooltip text={t('message.require_employee_parameter_hint')} /></label>
                            <YesNoSelect
                                name="requireEmployee"
                                onChange={(value) => setRequireEmployee(value)}
                                value={requireEmployee} />
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="setting-input">
                            <label className="form-label">Bloquear venda pela assinatura de cliente inadimplente? <HintTooltip text="Quando ativado (padrão), impede a venda quando o cliente tenta pagar usando o crédito da assinatura e está com cobrança em aberto ou assinatura cancelada. Desative para permitir a venda mesmo com o cliente inadimplente." /></label>
                            <YesNoSelect
                                name="blockSubscriptionSaleForDelinquent"
                                onChange={(value) => setBlockSubscriptionSaleForDelinquent(value)}
                                value={blockSubscriptionSaleForDelinquent} />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-12">
                        <Link to={"#"} className="btn btn-primary btn-md" onClick={() => save()}>{t('save_setting')}</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SalesSetting;
